<template>
    <div
    class="modal right fade trader-info c-offer-modal"
    id="bulk-send-to-ecn"
    tabindex="-1"
    role="dialog"
    aria-labelledby="bulkSendToEcnLabel"
    aria-hidden="true"
    >
    <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
        <div class="modal-content">
        <div class="modal-header">
            <h5 class="modal-title text-uppercase" id="bulkSendToEcnLabel">Bid Wanteds to be sent to ECN</h5>
            <button type="button" class="close"  @click="$emit('close')">
            <span aria-hidden="true">&times;</span>
            </button>
        </div>
        <div class="modal-body">
            <form  @submit.prevent="">
                <div class="form-row">
                    <template v-if="bulkResult">
                      <div class="form-group col-md-4" style="font-size: 14px;">
                          <div class="count-sec">
                              <label for="inputLast">Bid Wanteds sent to ECN : </label>
                              <span class=" ml-2">{{ bulkResult.BidWantedExistCount }}</span>
                          </div>
                      </div>
                      <div class="form-group col-md-4" style="font-size: 14px;">
                          <div class="count-sec">
                              <label for="inputLast">Bid Wanteds to be sent : </label>
                              <span class=" ml-2">{{ bulkResult.BidWantedSendingCount }}</span>
                          </div>
                      </div>
                      <div class="form-group col-md-4" style="font-size: 14px;">
                          <div class="count-sec">
                              <label for="inputLast">Existing offer matching BW : </label>
                              <span class=" ml-2">{{ bulkResult.OfferExistCount }}</span>
                          </div>
                      </div>
                    </template>

                    <div class="form-group col-md-4 required">
                        <label for="inputLast">Valid Until Time</label>
                        <ValidTime v-model="validTime"  v-bind:defaultTime="defaultValidUntilTime" />
                    </div>
                    <div class="form-group col-md-4 required">
                        <label for="inputLast">Firm Until Time</label>
                        <ValidTime v-model="firmUntilTime" v-bind:defaultTime="defaultFirmUntilTime"/>
                    </div>
                    <div class="form-group col-md-4 required">
                        <label for="inputLast">Settlement Date</label>
                        <DatePicker :disabledDates="disabledDatesSettlement"  v-model="settlementDate" placeholder="mm/dd/yyyy" typeable name="callDate" format="MM/dd/yyyy" :clear-button="false" :calendar-button="true" calendar-button-icon="fas fa-calendar-alt datepicker_icon"></DatePicker>
                    </div>
                </div>
            </form>
            <div v-if="loading" class="loader"><img src="@/assets/img/loader.svg" alt=""/></div>
            <div class="modal-footer bid">
                <button type="button" class="btn btn-secondary"  @click="$emit('close')">CLOSE</button>
                <button :disabled="!settlementDate || !firmUntilTime || !validTime "  @click="sendBulkToEcn()" type="button" class="btn btn-success" >SEND TO ECN</button>
            </div>
        </div>
        </div>
    </div>
    </div>
</template>

<script>
import ValidTime from "@/components/common/ValidTime"
import DatePicker from 'vuejs-datepicker';
import config from "@/config";
import authService from "@/authService";
export default {
    name: 'BaBulkSendToEcnModal',
    props: ['bulkPayload','bulkResult'],
    components :{
        DatePicker,
        ValidTime
    },
    data() {
        return {
            validTime: "",
            settlementDate: "",
            disabledDatesSettlement: {
                to : this.getYestedayDate()
            },
            firmUntilTime:"",
            userSettings : null,
            defaultValidUntilTime : "",
            defaultFirmUntilTime : "",
            loading : false
        }
    },
    methods:{
        sendBulkToEcn(){
            var beginningTime = this.moment(this.moment.utc(this.validTime).local().format("h:mma"), 'h:mma');
            var endTime = this.moment(this.moment.utc(this.firmUntilTime).local().format("h:mma"), 'h:mma');
            if(beginningTime.isAfter(endTime) || beginningTime.isSame(endTime)){
                this.$alert("Firm Until Time should be always higher than valid until time","","error");
                return ;
            }

            var message = `Are you sure you want to send bid wanted(s) to ECN?`;
            this.$confirm(message,"","question",{confirmButtonText:"SEND TO ECN",cancelButtonText : "NO"}).then(() => {
                this.loading = true;
                const auth = {
                        headers: { 'org-token' : authService.getOrgToken() }
                    };
                    var postData = { ...this.bulkPayload };
                        postData.expireMinutes = this.validTime;
                        postData.settlementDate = this.moment(this.settlementDate).format("MM/DD/YYYY")
                        postData.firmUntilMinutes = this.firmUntilTime;

                    this.$http
                    .post(
                    config.baseUrlAutoBidder +
                        "/bidwanted/bulk-send-to-ecn",postData,
                        auth
                    )
                    .then(() => {
                        this.loading = false;
                        this.$alert("Successfully sent to ecn","","success");
                        this.$emit('close');
                    }).catch(() => this.loading = false);
                })
            },
        getOrganizationSetting(){
            const auth = {
              headers: {'org-token' : authService.getOrgToken() }
            };
            this.$http
              .get(
                config.baseUrlBidSide +
                "/organization/bid-settings?type=OFFER",
                auth
              )
              .then(response => {
                this.settlementDate = response.data.settlementDate;
              })
        },
        getUserSetting(){
            this.loading = true;
            const auth = {
                headers: {'org-token' : authService.getOrgToken() }
            };
            this.$http
                .get(
                config.baseUrlBidSide +
                    "/tradebook/setting-list?cognitoSub="+authService.getUser().cognitoSub,
                    auth
                )
                .then(result => {
                    this.userSettings = result.data;
                    this.userSettings.forEach(element => {
                        if(element.setting == "BW_FIRM_UNTILL_TIME"){
                            this.defaultFirmUntilTime = element.value
                        }
                        if(element.setting == "BW_VALID_UNTILL_TIME"){
                            this.defaultValidUntilTime = element.value
                        }
                    });
                    this.loading = false;
                })
                .catch(() => {
                    this.loading = false;
                });
        },
    },
    mounted(){
        this.getUserSetting();
        this.getOrganizationSetting();
    }
};
</script>
<style scoped>
.count-sec {
    background-color: #2d86bf ;
    border: 1px solid #2d86bf ;
    border-radius: 15px;
    padding: 5px;
    text-transform: uppercase;
    text-align: center;
    font-weight: 900;
}
.count-sec span , .count-sec label {
    color: #fff !important;
}
</style>
